export const defaultWidth = 68;
export const defaultHeight = 93;
export const aspectRatio = `${defaultWidth} / ${defaultHeight}`;

export function getWidth(width?: string) {
  return width || `${defaultWidth}px`;
}
